import React from "react";
import { Button, Icon, Typography } from "@plum-xoxo/admin-dsm";
import { Link } from "react-router-dom";
import { app_path } from "config";
const PageHeader = ({
  title = "",
  subtitle = "",
  className = "",
  showBackButton = false,
  bottomMargin = "mb-0",
  button = null,
}) => {
  return (
    <>
      <div className="d-flex justify-content-between">
        <div className={className + " d-flex align-items-center"}>
          <div>
            {showBackButton && (
              <Link className="cursor-pointer" to={`/${app_path}/reports`}>
                <Icon className="mr-20" iconName="PlumBack" />
              </Link>
            )}
          </div>
          <div>
            <Typography.H2 color="dark" shade="c300">
              {title}
            </Typography.H2>
          </div>
        </div>
        <div>{button}</div>
      </div>
    </>
  );
};

export default PageHeader;
